/**
 * @desc getItemList
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.ResponseDto<
  Array<defs.omsFlow.AsMaterialRejectBillItemResponseDto>
>;
export function request(mrbNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/asMaterialRejectBillItem/list/${mrbNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
